import Text from './text';
import Password from './password';
import Textarea from './textarea';
import Suggest from './suggest';
import Checkbox from './checkbox';
import Select from './select';
import Date from './date';
import TransactionDate from './transactionDate';

export default {
  Text,
  Password,
  Textarea,
  Suggest,
  Checkbox,
  Select,
  Date,
  TransactionDate
}
